import React from 'react';

const ReactMarkdown = props => {
  const { children = '<p></p>', style } = props;
  const [scripts, setScripts] = React.useState([]);
  const [load, setLoad] = React.useState(false);

  // Local function to handle HTML content formatting
  const formatHtmlContent = (content) => {
    // Return content as is to preserve &nbsp; entities
    return content;
  };

  const handleFilterRemove = React.useRef(() => []);
  handleFilterRemove.current = () => {
    const scr = [];
    var doc = document.implementation.createHTMLDocument(); // Sandbox
    doc.body.innerHTML = children; // Parse HTML properly
    [].map.call(doc.getElementsByTagName('script'), function (el) {
      if (el?.attributes?.src?.value) {
        const script = document.createElement('script');
        script.src = el?.attributes?.src?.value; // whatever url you want here
        script.charset = 'utf-8';
        script.async = true;
        script.onload = function () {
          setLoad(true);
        };
        document.head.appendChild(script);
      } else {
        scr.push(el.textContent);
      }
    });
    return scr;
  };

  React.useEffect(() => {
    setScripts(handleFilterRemove.current());
  }, []);

  React.useEffect(() => {
    // eslint-disable-next-line no-eval
    if (load && scripts.length > 0) {
      // eslint-disable-next-line no-eval
      scripts.forEach(script => eval(script));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load]);

  return <div style={style} dangerouslySetInnerHTML={{ __html: formatHtmlContent(children) }} />;
};

export default ReactMarkdown;
